import React, { useContext, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { ExclamationTriangle } from 'react-bootstrap-icons'
import InfluencersList from './SidebarParts/InfluencersList'
import { CampaignContext } from '../../../../../contexts/CampaignContext'
import { LocaleContext } from '../../../../../contexts/LocaleContext'
import LocaleToggle from '../../../../Shared/LocaleToggle'
import SendRequestsModal from './SendRequestsParts/SendRequestsModal'
import { useReadOnly } from '../../../../../contexts/ReadOnlyContext'

export default observer(function DraftSidebar() {
  const { campaign } = useContext(CampaignContext)
  const readOnly = useReadOnly()
  const { localeState } = useContext(LocaleContext)
  const [showSendRequests, setShowSendRequests] = useState(false)

  return (
    <div className='w-[353px] h-full border-2 border-rb-widget-border dark:border-rb-dark-mode-lighter bg-white dark:bg-rb-dark-mode overflow-y-auto p-4'>
      <div className="flex items-center gap-3 p-3 mb-4 rounded-lg border-1 border-rb-widget-border dark:border-rb-dark-mode-lighter">
        {campaign.image && <img src={campaign.image} className="w-10 h-10 rounded-lg object-cover" />}
        <span className="font-bold dark:text-white">{campaign.name}</span>
      </div>

      <div className="flex justify-between items-center mb-4">
        <LocaleToggle locale={localeState.locale} onChange={localeState.setLocale} />

        {!readOnly && (
          <button
            onClick={() => setShowSendRequests(true)}
            className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-white rounded-lg bg-rb-green"
          >
            <ExclamationTriangle />
            Send Requests
          </button>
        )}
      </div>

      <InfluencersList />

      <SendRequestsModal isOpen={showSendRequests} onClose={() => setShowSendRequests(false)} />
    </div>
  )
})
